import { render } from "./MensaView.vue?vue&type=template&id=92260680"
import script from "./MensaView.vue?vue&type=script&lang=js"
export * from "./MensaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__